// SPDX-License-Identifier: AGPL-3.0-or-later

export const ExternalUrls = {
	SERVICE_STATUS: 'https://omnivybe.com.tr',
	BLUESKY: 'https://bsky.app/profile/omnivybe.com.tr',
} as const;
